import Index from './index.vue'
// import Create from './components/Create.vue'
import List from './components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'zakatAllocation',
    name: 'zakatAllocation',
    component: Index,
    title: 'Zakat Allocation',
    redirect: { name: 'zakatAllocation-list' },
    children: [
      
      {
        path: 'list',
        name: 'zakatAllocation-list',
        component: List,
      },
      
    ],
  },
]
